<editabel-treelist
  [apiName]="apiName"
  [label]="label"
  [name]="apiName"
  [inputEditorform]="inputEditorform"
  [IdName]="'Id'"
  reportName="SellCustomerGroup"
  pathPreFix="ُSELL"
  [ParentIdName]="'ParentId'"
  [expandableField]="'Title'">
</editabel-treelist>
